import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled from 'styled-components';

import hooks from '@g4/automation-hooks';

import { Option } from './';

export const List = styled.ul`
  width: 100%;
  list-style-type: none;
  padding: 0;
  font-weight: 400;
  overflow-y: auto;
`;

/** @visibleName Option List */
export class OptionList extends PureComponent {
  constructor(props) {
    super(props);

    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  static propTypes = {
    /**
      Determines which `Option` in the component has focus currently, with `-1`
      used to denote that none have focus
    */
    currentFocusIndex: PropTypes.number,
    /** Children must be `Option` components */
    children: (props, propName, componentName) => {
      const prop = props[propName];
      let error = null;
      React.Children.forEach(prop, child => {
        if (child.type !== Option) {
          error = new Error(
            '`' + componentName + '` children should be of type `Option`.'
          );
        }
      });
      return error;
    },
    /** injects the generated stylesheet */
    className: PropTypes.string,
    onKeyDown: PropTypes.func,
    automationHook: PropTypes.string,
  };

  static defaultProps = {
    currentFocusIndex: -1,
  };

  /**
   * Allows the use of the up and down arrow keys to traverse the list options
   */
  handleKeyDown(e) {
    const options = this.props.children;
    let currentFocusIndex = this.props.currentFocusIndex;

    if ([38, 40].indexOf(e.keyCode) !== -1) {
      switch (e.keyCode) {
        // up
        case 38:
          currentFocusIndex += currentFocusIndex > 0 ? -1 : 0;
          break;

        // down
        default:
          currentFocusIndex += currentFocusIndex < options.length - 1 ? 1 : 0;
          break;
      }

      this.props.onKeyDown(currentFocusIndex);
    }
  }

  render() {
    return (
      <div
        role="application"
        tabIndex="0"
        onKeyDown={this.handleKeyDown}
        className={this.props.className}
      >
        <List {...hooks.hook(this.props.automationHook)}>
          {React.Children.map(this.props.children, (child, index) => {
            return React.cloneElement(child, {
              autoFocus: index === this.props.currentFocusIndex,
            });
          })}
        </List>
      </div>
    );
  }
}

export default styled(OptionList)`
  width: 100%;
`;
